export default "__VITE_ASSET__4734f1b0__"